var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.2c7.8 0 14.2-6.4 14.2-14.2S23.8 1.8 16 1.8 1.8 8.2 1.8 16 8.2 30.2 16 30.2m0-25.4c6.2 0 11.2 5 11.2 11.2s-5 11.2-11.2 11.2S4.8 22.2 4.8 16 9.8 4.8 16 4.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.2c-.8 0-1.6.6-1.6 1.6v6c0 .8.6 1.6 1.6 1.6.8 0 1.6-.6 1.6-1.6v-6c0-1-.8-1.6-1.6-1.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10.4,
    r: 1.8
  })));
};
export default SvgInfo;